// get_workspace_category_cards
export const GET_WORKSPACE_CATEGORY_CARDS = 'get_workspace_category_cards';
export const GET_WORKSPACE_CATEGORY_CARDS_SUCCESSFUL =
  'get_workspace_category_cards_successfull';
export const GET_WORKSPACE_CATEGORY_CARDS_FAILED =
  'get_workspace_category_cards_failed';

// create_workspace_category_card
export const CREATE_WORKSPACE_CATEGORY_CARD = 'create_workspace_category_card';
export const CREATE_WORKSPACE_CATEGORY_CARD_SUCCESSFUL =
  'create_workspace_category_card_successfull';
export const CREATE_WORKSPACE_CATEGORY_CARD_FAILED =
  'create_workspace_category_card_failed';

// update_workspace_category_card
export const UPDATE_WORKSPACE_CATEGORY_CARD = 'update_workspace_category_card';
export const UPDATE_WORKSPACE_CATEGORY_CARD_SUCCESSFUL =
  'update_workspace_category_card_successfull';
export const UPDATE_WORKSPACE_CATEGORY_CARD_FAILED =
  'update_workspace_category_card_failed';

// delete_workspace_category_card
export const DELETE_WORKSPACE_CATEGORY_CARD = 'delete_workspace_category_card';
export const DELETE_WORKSPACE_CATEGORY_CARD_SUCCESSFUL =
  'delete_workspace_category_card_successfull';
export const DELETE_WORKSPACE_CATEGORY_CARD_FAILED =
  'delete_workspace_category_card_failed';
